import { Injectable } from '@jack-henry/frontend-utils/di';
import { exists } from '@jack-henry/frontend-utils/functions';
import {
    AchExceptionDetailDataDto,
    AchExceptionDetailSearchModelDto,
    AchExceptionsDecisionsActivityRequestModelDto,
    ArpClient,
    DashboardClient,
    ErrorResponseModelDto,
} from '@treasury/api/channel';
import { HttpResponse } from '@treasury/api/channel/generated/http-client';
import { AchException } from '../arp';
import { mapAchExceptionFiltersToRequest } from '../arp/mappings/ach-exception-filters-mapping';
import { mapAchExceptionsActivityFiltersToRequest } from '../arp/mappings/ach-exceptions-activity-filters-mapping';

@Injectable()
export class AchExceptionService {
    constructor(
        private readonly dashboardClient: DashboardClient,
        private readonly arpClient: ArpClient
    ) {}

    public async getAchExceptions() {
        const response = (await this.dashboardClient.dashboardGetWorkExceptions({
            type: 'achExceptions',
        })) as HttpResponse<AchExceptionDetailDataDto[], ErrorResponseModelDto>;

        if (!exists(response.data)) {
            return [];
        }
        return response.data.map((d: AchExceptionDetailDataDto) => new AchException(d));
    }

    public async searchAchExceptions(params: AchExceptionDetailSearchModelDto) {
        const request = mapAchExceptionFiltersToRequest(params);
        const response = await this.arpClient.arpFindAchExceptions(request);
        if (!response.data.achExceptionDetails) {
            return [];
        }
        // Fixes bad typing from the API
        return response.data.achExceptionDetails.map(
            d => new AchException(d as unknown as AchExceptionDetailDataDto)
        );
    }

    public async searchAchExceptionsActivity(
        params: AchExceptionsDecisionsActivityRequestModelDto | null
    ) {
        const request = mapAchExceptionsActivityFiltersToRequest(
            params
        ) as unknown as AchExceptionsDecisionsActivityRequestModelDto;
        const response = await this.arpClient.arpFindAchExceptionsDecisionsActivity(request);
        return response.data.items;
    }

    public async searchPaginatedAchExceptionsActivity(
        params: AchExceptionsDecisionsActivityRequestModelDto | null
    ) {
        const request = mapAchExceptionsActivityFiltersToRequest(
            params
        ) as unknown as AchExceptionsDecisionsActivityRequestModelDto;
        const response = await this.arpClient.arpFindAchExceptionsDecisionsActivity(request);
        return response.data.items;
    }
}
